import ExcelJS from 'exceljs';

export default class DetalleCXCExporter {
  static generateWorkbook(dataByDate) {
    const wb = new ExcelJS.Workbook();
    wb.creator = 'DetalleCXCExporter';
    wb.created = new Date();
    const ws = wb.addWorksheet('Reporte', {
      views: [{ state: 'frozen', ySplit: 1 }],
      pageSetup: {
        paperSize: 9,      // A4 landscape
        orientation: 'landscape',
        margins: { top: 0.5, left: 0.5, right: 0.5, bottom: 0.5 }
      }
    });

    // Definición de columnas
    ws.columns = [
      { header: 'Producto',    key: 'producto',  width: 30 },
      { header: 'Cantidad',    key: 'cantidad',  width: 12 },
      { header: 'Monto',       key: 'monto',     width: 15 },
      { header: 'Fecha',       key: 'fecha',     width: 12 },
    ];

    // Estilo de cabecera
    const headerRow = ws.getRow(1);
    headerRow.height = 20;
    headerRow.font = { name: 'Calibri', size: 12, bold: true, color: { argb: 'FFFFFFFF' } };
    headerRow.alignment = { horizontal: 'center', vertical: 'middle' };
    headerRow.eachCell(cell => {
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF4472C4' } };
      cell.border = {
        top: { style: 'thin' }, left: { style: 'thin' },
        bottom: { style: 'thin' }, right: { style: 'thin' }
      };
    });
    ws.autoFilter = { from: 'A1', to: 'D1' };

    let grandTotal = 0;

    Object.entries(dataByDate).forEach(([fecha, productos]) => {
      // Encabezado de sección
      const secRow = ws.addRow({ producto: `Fecha: ${fecha}` });
      ws.mergeCells(`A${secRow.number}:D${secRow.number}`);
      const secCell = secRow.getCell('producto');
      secRow.height = 18;
      secCell.font      = { name: 'Calibri', size: 11, bold: true };
      secCell.alignment = { horizontal: 'center' };
      secCell.fill      = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFBFBFBF' } };
      secCell.border    = { bottom: { style: 'thin' } };

      // Detalle de productos
      productos.forEach((prod, idx) => {
        const monto = prod.Cnt * prod.Pco.C;
        grandTotal += monto;

        const row = ws.addRow({
          producto: prod.Nombre,
          cantidad: prod.Cnt,
          monto,
          fecha: prod.fecha instanceof Date ? prod.fecha : new Date(prod.fecha),
        });

        // Formato numérico puro
        row.getCell('cantidad').numFmt = '#,##0';
        row.getCell('monto').   numFmt = '#,##0.00';
        row.getCell('fecha').   numFmt = 'dd/mm/yyyy';

        // Zebra striping solo en celdas con datos
        if (idx % 2 === 1) {
          row.eachCell({ includeEmpty: false }, cell => {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFEFEFEF' }
            };
          });
        }
      });

      // Subtotal de este grupo
      const subtotal = productos.reduce((sum, p) => sum + p.Cnt * p.Pco.C, 0);
      const subRow = ws.addRow({ producto: 'Subtotal', monto: subtotal });
      ws.mergeCells(`A${subRow.number}:B${subRow.number}`);
      const lblCell = subRow.getCell('producto');
      lblCell.font      = { name: 'Calibri', size: 11, bold: true };
      lblCell.alignment = { horizontal: 'right', vertical: 'middle' };
      lblCell.fill      = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD9E1F2' } };
      lblCell.border    = {
        top: { style: 'thin' },
        bottom: { style: 'thin' }
      };
      const valCell = subRow.getCell('monto');
      valCell.numFmt   = '#,##0.00';
      valCell.font     = { name: 'Calibri', size: 11, bold: true };
      valCell.fill     = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD9E1F2' } };
      valCell.border   = {
        top: { style: 'thin' },
        bottom: { style: 'thin' }
      };
    });

    // Línea en blanco antes del Total General
    ws.addRow([]);

    // Total General
    const genRow = ws.addRow({ producto: 'Total General', monto: grandTotal });
    ws.mergeCells(`A${genRow.number}:B${genRow.number}`);
    const genLbl = genRow.getCell('producto');
    genLbl.font      = { name: 'Calibri', size: 12, bold: true };
    genLbl.alignment = { horizontal: 'right', vertical: 'middle' };
    genLbl.fill      = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFBDD7EE' } };
    genLbl.border    = {
      top: { style: 'medium' },
      bottom: { style: 'medium' }
    };
    const genVal = genRow.getCell('monto');
    genVal.numFmt  = '#,##0.00';
    genVal.font    = { name: 'Calibri', size: 12, bold: true };
    genVal.fill    = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFBDD7EE' } };
    genVal.border  = {
      top: { style: 'medium' },
      bottom: { style: 'medium' }
    };

    return wb;
  }

  static async generateExcelBuffer(dataByDate) {
    const wb = DetalleCXCExporter.generateWorkbook(dataByDate);
    return wb.xlsx.writeBuffer();
  }
}
